
import { defineComponent, computed, ref } from 'vue';
import { useStore } from '@/store';
import { Client } from '@/types/app';
import { alphabetize, lowerCaseIncludes, useModalState } from '@/utils';
import ClientsTable from '@/components/tables/ClientsTable.vue';
import ClientAddEditFormModal from '@/components/modal/ClientAddEditFormModal.vue';
import ClientDeleteFormModal from '@/components/modal/ClientDeleteFormModal.vue';
import ButtonInput from '@/components/form-controls/base/ButtonInput.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import MaterialIconButton from '@/components/form-controls/MaterialIconButton.vue';

export default defineComponent({
  name: 'ClientsManager',
  components: {
    ClientAddEditFormModal,
    ClientDeleteFormModal,
    ClientsTable,
    MaterialIconButton,
    TextInput,
    ButtonInput
  },
  setup() {
    const store = useStore();
    const searchValue = ref('');
    const clients = computed(() => store.getters.clients.get);
    const filteredClients = computed(() =>
      clients.value.filter(
        client =>
          lowerCaseIncludes(client.name, searchValue.value) ||
          lowerCaseIncludes(client.email, searchValue.value) ||
          lowerCaseIncludes(client.phone, searchValue.value)
      )
    );

    const sortedClients = computed(() => alphabetize(filteredClients.value, 'name'));

    const deleteClient = (client: Client) => store.dispatch.clients.delete(client);

    const [selectedAddEditClient, isAddEditModalOpen, openAddEditModal] = useModalState<Client>();
    const [selectedDeleteClient, isDeleteModalOpen, openDeleteModal] = useModalState<Client>();

    return {
      searchValue,
      sortedClients,
      deleteClient,
      selectedAddEditClient,
      isAddEditModalOpen,
      openAddEditModal,
      selectedDeleteClient,
      isDeleteModalOpen,
      openDeleteModal
    };
  }
});
